module.exports = __webpack_public_path__ + "img/telegram.90e84bb5.svg";